(function($) {

	'use strict';

	var init = function() {

        if($('body').hasClass('home') || $('body').hasClass('page-template-template-custom-homepage') || $('body').hasClass('page-template-template-listing-jobs') || $('body').hasClass('page-template-default') || $('body').hasClass('formation-template-default')) {
            manageParallaxe();
        }

    };
    
    var manageParallaxe = function() {

        var $element = $('main');

        $(window).scroll(function() {

            var parallaxe = ($(document).scrollTop() / ($(document).height() - $(window).height())) * 16;
            parallaxe = Math.round((parallaxe + Number.EPSILON) * 100) / 100;

            $element.css('--parallaxe', '-' + parallaxe + '%');

        }).scroll();
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);